import { useState, useEffect } from 'react'
import { getAccountConnectionEvents } from '../api'

export default function useConnectionEvents(modelId, { enabled = true } = {}) {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(false)

  function load() {
    if (!modelId || !enabled) return
    setLoading(true)
    getAccountConnectionEvents(modelId)
      .then((r) => setEvents(Array.isArray(r?.data) ? r.data : []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (modelId && enabled) load()
  }, [modelId, enabled])

  return { events, loading, load }
}
